/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBedtimeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-bedtime"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12.1 22.32Q9.95 22.32 8.05 21.5Q6.15 20.68 4.74 19.26Q3.33 17.85 2.5 15.95Q1.68 14.05 1.68 11.9Q1.68 8.7 3.42 6.05Q5.17 3.4 8.15 2.25Q8.95 1.93 9.66 2.36Q10.38 2.8 10.4 3.6Q10.45 5.63 11.14 7.47Q11.82 9.32 13.25 10.75Q14.68 12.18 16.52 12.88Q18.38 13.57 20.4 13.57Q21.2 13.57 21.65 14.21Q22.1 14.85 21.82 15.6Q20.73 18.68 18.05 20.5Q15.38 22.32 12.1 22.32Z" fill={color} />
    </svg>
  );
}
